import { useQuery } from '@tanstack/react-query';
import { api } from '@/lib/api';
import type { ObraDetalle } from '@/types/api';

// Header de DetalleObra (GET /api/obras/:cc) — query propia ['obra', cc],
// separada de ['obras'] (la galería): evita traer las ~260 obras solo para
// mostrar el header de una. 404 si no existe/es Central — lo maneja la
// página vía isError + ApiError.status (mismo patrón que useObras).
export function useObra(cc: string) {
  return useQuery({
    queryKey: ['obra', cc],
    queryFn: () => api<ObraDetalle>(`/api/obras/${encodeURIComponent(cc)}`),
    enabled: cc.length > 0,
    staleTime: 60_000,
  });
}
